module.exports = __webpack_public_path__ + "eb2104b76fd7accfcddeb4a6426d55f1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BB.svg
// module id = XSBQ
// module chunks = 0